import React, { useState } from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CRow,
} from "@coreui/react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Field, reduxForm } from "redux-form";
import { resetPass } from "../../Redux/login/Action";
import { resetPassword as validate } from "../validate/validate";
import { renderPasswordInput } from "../FormField/FormField";
import { useParams } from "react-router-dom";

const ResetPassword = ({ handleSubmit }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isDisabled, setIsDisabled] = useState(false);
  const { type, token } = useParams();

  const submit = (values) => {
    setIsDisabled(true);

    dispatch(resetPass({ token: token, type, ...values }))
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.message);
          if (type === "admin") {
            history.push("/login");
          }
        } else {
          toast.error("Please try again.");
          setIsDisabled(false);
        }
      })
      .catch((err) => {
        setIsDisabled(false);
        if (err?.response?.data?.status === 400) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Please try again.");
        }
      });
  };

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer className="py-4">
        <CRow className="justify-content-center">
          <CCol md="9" lg="7" xl="6">
            <CCard className="mx-4">
              <CCardBody className="p-4">
                <CForm onSubmit={handleSubmit(submit)}>
                  <h1>
                    <span role="img" aria-label="lock">
                      🔏
                    </span>{" "}
                    Reset Password
                  </h1>

                  <Field
                    type="password"
                    component={renderPasswordInput}
                    name="password"
                    labelName="New Password"
                    placeholder="Enter new password"
                    className="form-control"
                  />

                  <Field
                    type="password"
                    component={renderPasswordInput}
                    name="confirm_password"
                    labelName="Confirm Password"
                    placeholder="Re-enter new password"
                    className="form-control"
                  />

                  {isDisabled ? (
                    <h4 className="mt-4 text-center">Please Wait...</h4>
                  ) : (
                    <CButton
                      disabled={isDisabled}
                      className="mt-4"
                      type="submit"
                      color="info"
                      block
                    >
                      Submit
                    </CButton>
                  )}
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default reduxForm({
  form: "ResetPasswordForm",
  validate,
})(ResetPassword);
